import { Deserializable } from '../protocols/deserializable';
import { BankAccount } from '../../views/banking/models/bank-account';
import { ConsentWaiverAttachment } from './consent-waiver-attachment';
import { AnnuityType } from '../annuities/dto/annuity-type';
import { AnnuityPensionAnnuityTypeIdEnum } from '../enum/shared/annuity-pension-annuity-type-id.enum';

export class AnnuitySetupSubmissionData implements Deserializable {
  public id!: string;
  public annuityTypeId!: AnnuityPensionAnnuityTypeIdEnum;
  public annuityType!: AnnuityType;
  public mandatoryRetirement!: boolean;
  public smallPensionPayoutOptIn!: boolean;
  public estimatedMonthlyBenefit!: number | null;
  public estimatedSurvivorBenefit!: number | null;
  public estimatedPurchasePrice!: number;
  public estimatedAnnuityConversionRate!: number;
  public effectiveDate!: string;
  public bankAccountId!: number | null;
  public bankAccount!: BankAccount | null;
  public jointPensionerId!: number | null;
  public jointPensionerName!: string | null;
  public definedContributionAmountToUse!: number | null;
  public definedContributionUseEntireBalance!: boolean;
  public variableBenefitAmountToUse!: number | null;
  public variableBenefitUseEntireBalance!: boolean;
  public consentWaiverDateSigned!: string | null;
  public consentWaiverEffectiveDate!: string | null;
  public consentWaiver!: ConsentWaiverAttachment | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.annuityType) {
      this.annuityType = Deserialize.instanceOf(AnnuityType, this.annuityType);
    }

    if (this.bankAccount) {
      this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
    }

    if (this.consentWaiver) {
      this.consentWaiver = Deserialize.instanceOf(ConsentWaiverAttachment, this.consentWaiver);
    }
  }
}
